<template>
  <div class="custom-quiz-widget">
    <dashboard-widget-header title="Custom Study"></dashboard-widget-header>
    <div
      class="custom-quiz-tile-container"
    >
      <div
        class="tile tile-blue"
        :class="{ 'two-column': !showSessionsTile }"
        @click="createQuiz"
      >
        <button
          class="button-tile"
          @click="createQuiz"
        >
          <icon name="file-plus-1" />
        </button>
        <div>
          <div class="header">
            <icon
              v-if="isLocked"
              name="lock-slot"
              variant="white"
              class="lock-icon"
            ></icon>
            <span>Customize your study session</span>
          </div>
          <div class="sub-header">
            You pick length, subject(s) and format
          </div>
        </div>
      </div>
      <div
        v-if="showSessionsTile"
        class="tile"
        @click="viewCreatedSessions"
      >
        <button
          class="button-tile"
          @click="viewCreatedSessions"
        >
          <icon name="list" />
        </button>
        <div>
          <div class="header">
            View created sessions
          </div>
          <div class="sub-header">
            A list of the sessions you've created
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@components/dashboard-widgets/header.vue';
import Icon from '@components/singletons/icon';
import DashboardWidgetMixin from '@/mixins/dashboardWidget';
import { PAID_FEATURES } from '@/utils/acl';

export default {
  components: {
    DashboardWidgetHeader,
    Icon,
  },
  mixins: [DashboardWidgetMixin],
  props: {
    config: {
      type: Object,
    },
    dashboard: {
      type: Object,
    },
  },
  computed: {
    isLocked() {
      return !this.$access(this.$store, 'feature', PAID_FEATURES.CUSTOM_QUIZZES);
    },
    showSessionsTile() {
      return this.quizCategories.length;
    },
    query() {
      if (this.navigationItem) {
        return { nav: this.navigationItem.query };
      }
    },
    quizCategories() {
      const userQuizCategoryType = this.$store.getters['categoryTypes/userQuizCategoryType'];
      const ids = this.$store.getters['categories/type'][userQuizCategoryType.id] || [];
      return ids.map(id => this.$store.getters['categories/categories'][id]);
    },
  },
  methods: {
    createQuiz() {
      if (this.isLocked) {
        this.showUpSellModal();
        return;
      }
      this.$router.push({
        name: 'quizzes#create',
        query: this.query,
      });
    },
    showUpSellModal() {
      const source = { type: 'Custom Quiz Widget' };
      const analyticParams = {
        dashboard: this.dashboard,
        destination: 'Upgrade Screen',
        widget: this.config,
      };
      this.$analytics.events.selectedRateLimitWidget(analyticParams);
      this.$store.dispatch('ui/toggleUpsellModal', { show: true, source });
    },
    viewCreatedSessions() {
      if (this.isLocked) {
        this.showUpSellModal();
        return;
      }
      this.$router.push({
        name: 'quizzes#index',
        query: {
          ...this.query,
          tab: 'my-quizzes',
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-quiz-tile-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @include breakpoint(tablet) {
    grid-template-columns: 1fr 1fr;

    .two-column {
      grid-column: span 2;
    }
  }

  @include breakpoint(desktop) {
    grid-template-columns: 1fr 1fr;

    .two-column {
      grid-column: span 2;
    }
  }
}

.button-tile {
  padding: 8px;
  background: white;
  border-radius: var(--radius-md);
  height: rem-calc(40);
  width: rem-calc(40);
  border: 1px solid rgba(228, 231, 236, 1);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  box-shadow: 0px -2px 0px 0px rgba(16, 24, 40, 0.05) inset;
  box-shadow: 0px 0px 0px 1px rgba(16, 24, 40, 0.18) inset;

}

.lock-icon {
  transform: translateY(3px);
}

.tile {
  display: flex;
  cursor: pointer;
  gap: 16px;
  border-radius: var(--radius-xl);
  background-color: white;
  padding: 16px;
  border: 1px solid rgba(228, 231, 236, 1);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.tile-blue {
  background: rgba(21, 94, 239, 1);
  color: white;
}

.header {
  font-size: var(--Fontsizetext-md);
  font-weight: 600;
  line-height: var(--Lineheighttext-md);
}

.sub-header {
  font-size: var(--Fontsizetext-sm);
  font-weight: 400;
  line-height: var(--Lineheighttext-sm);
}
</style>
